import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useVersionCheck } from '@/hooks/useVersionCheck';

/**
 * Banner persistente que aparece quando há nova versão disponível.
 * Sem botão de fechar — só desaparece ao clicar "Atualizar" (reload).
 */
export default function UpdateBanner() {
  const { updateAvailable } = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    // Positioned by the shell's `.bottom-notice-stack` (App.tsx), which also
    // stacks the reconnecting pill above it.
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      padding: '10px 20px',
      borderRadius: 12,
      background: 'rgba(21, 70, 128, 0.95)',
      backdropFilter: 'blur(12px)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      border: '1px solid rgba(255,255,255,0.1)',
      color: '#ffffff',
      animation: 'updateBannerSlideUp 0.3s ease-out',
    }}>
      <RefreshCw size={18} color="#60a5fa" />
      <span style={{ fontSize: 13, fontWeight: 600 }}>
        Nova versão disponível
      </span>
      <button
        onClick={() => window.location.reload()}
        style={{
          marginLeft: 4,
          padding: '6px 16px',
          borderRadius: 8,
          border: 'none',
          background: '#60a5fa',
          color: '#0f172a',
          fontSize: 12,
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'filter 0.15s, transform 0.15s',
        }}
        onMouseEnter={e => { e.currentTarget.style.filter = 'brightness(1.1)'; e.currentTarget.style.transform = 'scale(1.03)'; }}
        onMouseLeave={e => { e.currentTarget.style.filter = 'none'; e.currentTarget.style.transform = 'none'; }}
      >
        Atualizar
      </button>

      <style>{`
        @keyframes updateBannerSlideUp {
          from { transform: translateY(20px); opacity: 0; }
          to   { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
